import { Browser } from "@capacitor/browser";
import { Capacitor } from "@capacitor/core";
import cx from "classnames";
import { useRef } from "react";

import { handleLinkClick } from "utils/androidByPassDeepLinkClick";
import { getAdminUrl } from "utils/functions";

type RepeatMDFooterV3Props = {
  showLinks?: boolean;
  showShopTerms?: boolean;
};

export const RepeatMDFooterV3 = (props: RepeatMDFooterV3Props) => {
  const anchorRef = useRef(null);
  return (
    <div>
      {props.showLinks && (
        <div className="flex items-center justify-center gap-6 px-0 pb-7 pt-3">
          <button
            className="text-bold3 text-secondary"
            rel="noopener noreferrer"
            onClick={() =>
              Browser.open({ url: "https://myrepeat.com/terms.html" })
            }
          >
            Terms of service
          </button>
          <button
            className="text-bold3 text-secondary"
            rel="noopener noreferrer"
            onClick={() =>
              Browser.open({ url: "https://myrepeat.com/privacy-policy.html" })
            }
          >
            Privacy policy
          </button>
          <button
            className="text-bold3 text-secondary"
            rel="noopener noreferrer"
            onClick={() =>
              Browser.open({ url: "https://myrepeat.com/help.html" })
            }
          >
            Help
          </button>
          {!Capacitor.isNativePlatform() && (
            <a
              ref={anchorRef}
              className="text-bold3 text-secondary"
              href={getAdminUrl()}
              target="_self"
              rel="noopener noreferrer"
              onClick={() => {
                handleLinkClick(anchorRef);
              }}
            >
              Admin
            </a>
          )}
        </div>
      )}
      {props.showShopTerms && (
        <span
          className={cx(
            "flex w-full justify-center gap-1 pb-1 text-chip text-primary",
            "flex-wrap font-normal"
          )}
        >
          By placing this order you agree to our{" "}
          <button
            className="text-brand-color"
            rel="noopener noreferrer"
            onClick={() =>
              Browser.open({ url: "https://myrepeat.com/privacy-policy.html" })
            }
          >
            Privacy policy
          </button>
          and{" "}
          <button
            className="text-brand-color"
            rel="noopener noreferrer"
            onClick={() =>
              Browser.open({ url: "https://myrepeat.com/terms.html" })
            }
          >
            Terms of Use
          </button>
        </span>
      )}
    </div>
  );
};
